module.exports = __webpack_public_path__ + "media/images/icon-arrow-up-4478a6b99bea30bedea6937dc4177cec.svg";